export function getAmountFromUrl(paramName = 'amount'): number | undefined {
  const urlParams = new URLSearchParams(window.location.search);
  const amount = urlParams.get(paramName);

  if (amount) {
    return parseInt(amount);
  }

  return undefined;
}
